module.exports = __webpack_public_path__ + "img/ad.c3350c64.png";